<template>
  <div class="layout converter-layout">
    <navigation></navigation>
    <div class="fixed-forgrid">
      <slot/>
    </div>
    <qaz-footer></qaz-footer>
  </div>
</template>

<script>
import Navigation from "@/components/navigation/ConverterNavigation.vue";
import Footer from "@/components/ConverterFooter.vue";

export default {
  components: {
    navigation: Navigation,
    "qaz-footer": Footer
  }
};
</script>

<style lang="scss" scoped>
.converter-layout {
  background: #ffffff !important;
}
</style>
